export default __webpack_public_path__ + "static/media/sticker-P.e0660f56.png";